import React, { createContext, useContext, useState } from 'react';
import { useGetMovieVideosQuery } from '../services/movieApi';

const Context = createContext();

export const StateContext = ({ children }) => {
  const [modal, setModal] = useState(false);
  const [trailerId, setTrailerId] = useState(315162);

  const { data: movieTrailer } = useGetMovieVideosQuery({
    movieId: trailerId,
  });

  return (
    <Context.Provider
      value={{ setModal, setTrailerId, trailerId, modal, movieTrailer }}
    >
      {children}
    </Context.Provider>
  );
};

export const useStateContext = () => useContext(Context);
